module.exports = __webpack_public_path__ + "img/i_nav_list_new_on.645a7c48.svg";